/**
 *
 * @module commerceClientExtrasMap
 *
 */

import Check from 'check-types';
import AppAccount from './appAccount';

/**
 *
 * @class CommerceClientExtrasMap
 *
 */
export default class CommerceClientExtrasMap {

    /**
     *
     * @param {String} namespace
     * @param {String} clientId
     * @param {Object} appAccount
     *
     */
    constructor(namespace, clientId, appAccount, createPaymentMethodRegionalEndpoints) {

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.namespace = namespace;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.clientId = clientId;

        /**
         *
         * @access public
         * @type {AppAccount}
         *
         */
        this.appAccount = this.processAppAccount(appAccount);

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.createPaymentMethodRegionalEndpoints = createPaymentMethodRegionalEndpoints;

    }

    /* #region private: */

    /**
     *
     * @access private
     * @param {Object} appAccount
     * @returns {AppAccount}
     *
     */
    processAppAccount(appAccount) {

        if (Check.not.object(appAccount)) {
            return new AppAccount();
        }

        const { id, name, namespaceId } = appAccount;

        return new AppAccount(id, name, namespaceId);

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/commerceClientExtrasMap.js